import { render, staticRenderFns } from "./AdminChangeOwnershipCasesModal.vue?vue&type=template&id=48800297"
import script from "./AdminChangeOwnershipCasesModal.vue?vue&type=script&lang=js"
export * from "./AdminChangeOwnershipCasesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports